module.exports = __webpack_public_path__ + "static/media/wifi-a.0d77f211.png";